import React, { useEffect, useState } from 'react';
import { CgShoppingBag } from 'react-icons/cg';
import { toast } from 'sonner';
import { SubmitButton } from '../../services/pipeline/Form/Common/SubmitButton';
import { OrderTypeContainer } from './OrderTypeContainer';

const order_types = [
  { name: 'Add Lien Search', id: 'lienSearch' },
  { name: 'Add Estoppel', id: 'estoppel' },
  { name: 'Add Survey', id: 'survey' }
];

export const OrderTypeSection = ({ handleForward, handleBack, setOrderType, defaultActiveOrderType }) => {
  const [activeOrderType, setActiveOrderType] = useState([]);

  const onClick = value => {
    if (activeOrderType.includes(value)) {
      const newList = activeOrderType.filter(item => item !== value);
      setActiveOrderType(newList);
      return;
    }
    const updatedOrderType = [value, ...activeOrderType];
    const sortedOrderType = order_types.map(order => order.id).filter(id => updatedOrderType.includes(id));
    setActiveOrderType(sortedOrderType);
  };

  const handleSubmit = () => {
    if (activeOrderType.length === 0) {
      toast.error('Please select atleast one order type!', { duration: 2000 });
      return;
    }
    setOrderType(activeOrderType);
    handleForward();
  };

  useEffect(() => {
    setActiveOrderType(defaultActiveOrderType);
  }, [defaultActiveOrderType]);

  return (
    <>
      <div className="order-type-section">
        <p className="d-flex align-items-center order-type-section-title">
          <CgShoppingBag className="mr-2" />
          Place Your Order
        </p>
        <p className="order-type-section-subtitle">
          Select the services you'd like to include in your order. You can choose multiple options.
        </p>
        <div className="order-type-list">
          {order_types?.map(item => {
            const isSelected = activeOrderType?.includes(item.id);
            return (
              <OrderTypeContainer
                key={item.id}
                id={item.id}
                name={item.name}
                onClick={onClick}
                isSelected={isSelected}
              />
            );
          })}
        </div>
      </div>
      <SubmitButton onCancel={handleBack} onSubmit={handleSubmit} />
    </>
  );
};
